import { render } from "./ProductCard.vue?vue&type=template&id=3d5e5e68&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=3d5e5e68&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5e5e68"]])

export default __exports__